import React from 'react';
import { Card, Typography, Row, Col, Divider } from 'antd';
import { ArrowRightOutlined, CheckCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { HOTLINE } from 'src/constants/constants';
import Button from 'src/components/MyButton/Button';
import { useNavigate } from 'react-router-dom';
import ROUTER from 'src/router';

const { Title, Text, Paragraph } = Typography;

const InsuranceGuide = () => {
    const navigate = useNavigate()
    const steps = [
        {
            number: 1,
            title: 'Truy cập website',
            content: (
                <>
                    Truy cập link:{' '}
                    <a
                        href="https://tracuu.baohiemtrachnhiemdansu.vn/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#1890ff' }}
                    >
                        https://tracuu.baohiemtrachnhiemdansu.vn/
                    </a>
                </>
            ),
        },
        {
            number: 2,
            title: 'Chọn dịch vụ mua mới',
            content: (
                <>
                    Kéo xuống mục <strong>Dịch vụ nổi bật</strong> → chọn{' '}
                    <strong>Mua bảo hiểm mới</strong>.
                </>
            ),
        },
        {
            number: 3,
            title: 'Chọn loại xe',
            content: (
                <>
                    Hệ thống hiển thị popup chọn loại xe:{' '}
                    <strong>Bảo hiểm ô tô</strong> hoặc <strong>Bảo hiểm xe máy</strong>.
                </>
            ),
        },
        {
            number: 4,
            title: 'Nhập thông tin xe',
            content: (
                <>
                    Nhập thông tin xe (Biển kiểm soát, Loại xe,...) → bấm{' '}
                    <strong>Tiếp theo</strong>.
                </>
            ),
        },
        {
            number: 5,
            title: 'Nhập thông tin khách hàng',
            content: (
                <>
                    Nhập thông tin khách hàng (Tên khách hàng, SĐT,...) → bấm{' '}
                    <strong>Tiếp theo</strong>.
                </>
            ),
        },
        {
            number: 6,
            title: 'Kiểm tra gói bảo hiểm & giá',
            content: (
                <>
                    <Paragraph>
                        Kiểm tra và chọn:
                        <ul style={{ margin: '8px 0 16px 20px' }}>
                            <li>Thời gian bắt đầu</li>
                            <li>Thời hạn bảo hiểm</li>
                            <li>Nhà cung cấp</li>
                        </ul>
                    </Paragraph>
                    <Paragraph>
                        Hệ thống hiển thị: <strong>giá niêm yết</strong>,{' '}
                        <strong>giá gồm VAT</strong> và <strong>giá bán</strong>.
                    </Paragraph>
                    <Text strong>→ bấm Tiếp tục.</Text>
                </>
            ),
        },
        {
            number: 7,
            title: 'Kiểm tra ấn chỉ nháp',
            content: (
                <>
                    Hệ thống hiển thị ấn chỉ nháp. Kiểm tra kỹ thông tin → bấm{' '}
                    <strong>Xác nhận</strong> để sang bước thanh toán.
                </>
            ),
        },
        {
            number: 8,
            title: 'Thanh toán',
            content: (
                <>
                    <Paragraph>
                        Quét mã QR hoặc chuyển khoản theo thông tin hiển thị.
                    </Paragraph>
                    <Text strong style={{ color: '#cf1322' }}>
                        Chú ý chuyển đúng số tiền và đúng nội dung chuyển khoản.
                    </Text>
                    <br />
                    <br />
                    Sau khi chuyển → bấm <strong>Xác nhận</strong> để hệ thống kiểm tra
                    giao dịch.
                </>
            ),
        },
        {
            number: 9,
            title: 'Hoàn tất & nhận ấn chỉ',
            content: (
                <>
                    Thanh toán thành công. Hệ thống phát hành ấn chỉ bảo hiểm cho biển
                    số xe. Bạn có thể xem, tải xuống hoặc chia sẻ ấn chỉ trong danh sách
                    hiển thị.
                </>
            ),
        },
    ];

    return (
        <div style={{ padding: '16px', background: '#f0f2f5', minHeight: '100vh' }}>
            <Row justify="center">
                <Col xs={24} sm={22} md={20} lg={16} xl={14}>
                    <div style={{ textAlign: 'center', marginBottom: 32 }}>
                        <Title level={3}>Hướng dẫn mua bảo hiểm trách nhiệm dân sự</Title>
                        <Text type="secondary">
                            Quy trình chi tiết 9 bước trên hệ thống
                        </Text>
                    </div>

                    {steps.map((step) => (
                        <Card
                            key={step.number}
                            style={{
                                marginBottom: 16,
                                borderRadius: 8,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                            }}
                        >
                            <Row gutter={16} align="top">
                                <Col flex="0 0 56px">
                                    <div
                                        style={{
                                            width: 48,
                                            height: 48,
                                            borderRadius: '50%',
                                            background: '#1890ff',
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 20,
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {step.number}
                                    </div>
                                </Col>

                                <Col flex="1">
                                    <Title level={5} style={{ margin: '0 0 12px 0' }}>
                                        {step.title}
                                    </Title>
                                    {step.content}
                                </Col>
                            </Row>
                        </Card>
                    ))}

                    <Divider />

                    <div style={{ textAlign: 'center', color: '#8c8c8c', fontSize: 14, marginBottom: 32 }}>
                        <p>Lưu ý: Vui lòng kiểm tra kỹ thông tin trước khi thanh toán.</p>
                        <p>Hotline hỗ trợ (nếu có): {HOTLINE}</p>
                    </div>

                    {/* Button CTA - Đặt ở cuối */}
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            type="primary"
                            size="large"
                            icon={<ShoppingCartOutlined />}
                            onClick={() => navigate(ROUTER.ORDER_SEAL)} // Thay bằng route thực tế của bạn
                            block // Full width trên mobile
                            style={{
                                height: 56,
                                fontSize: 18,
                                fontWeight: 600
                            }}
                        >
                            Đăng ký ngay
                        </Button>

                        {/* Button phụ nếu muốn thêm lựa chọn */}
                        {/* <Button
                            type="default"
                            size="large"
                            icon={<ArrowRightOutlined />}
                            onClick={() => navigate('/mua-bao-hiem-moi')} // Hoặc route khác
                            style={{ marginTop: 16, height: 48 }}
                            block
                        >
                            Tiến hành mua bảo hiểm mới
                        </Button> */}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default InsuranceGuide;